"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _resize = require("./resize.constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var resizeHoc = function resizeHoc() {
  var ratioMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _resize.sizeRatioMap;
  return function (WrappedComponent) {
    var Resize = /*#__PURE__*/function (_React$Component) {
      _inherits(Resize, _React$Component);

      var _super = _createSuper(Resize);

      function Resize(props) {
        var _this;

        _classCallCheck(this, Resize);

        _this = _super.call(this, props);

        _defineProperty(_assertThisInitialized(_this), "updateElementSize", function () {
          if (_this.props.fixedWidth || !_this.element.current) return;

          var width = _this.element.current.getBoundingClientRect().width;

          if (_this.framedFlagSwitched) {
            // 48px because thats the "large" box size
            width = width + (_this.props.framed ? -48 : 48);
          }

          var height = _this.calculateHeight(width);

          var newState = {};

          if (!isNaN(height) && height !== _this.state.height) {
            newState.height = height;
          }

          if (!isNaN(width) && width !== _this.state.width) {
            newState.width = width;
          }

          if (Object.keys(newState).length > 0) {
            _this.setState(_objectSpread(_objectSpread({}, _this.state), newState));
          }
        });

        _defineProperty(_assertThisInitialized(_this), "calculateHeight", function () {
          var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.width;
          return width / _this.ratio;
        });

        _this.sizeRatioMap = ratioMap;
        _this.framedFlagSwitched = false;
        _this.state = {
          width: props.width || 0,
          height: props.height || 0,
          src: props.src
        };

        if (props.fixedWidth) {
          _this.state.width = props.fixedWidth;
          _this.state.height = _this.calculateHeight(props.fixedWidth);
        }

        _this.element = /*#__PURE__*/_react["default"].createRef();
        return _this;
      }

      _createClass(Resize, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          // if (!this.state.height || !this.state.width) {
          this.updateElementSize(); // }

          window.addEventListener('resize', this.updateElementSize);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener('resize', this.updateElementSize);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          this.framedFlagSwitched = prevProps.framed !== this.props.framed;

          if (prevProps.size !== this.props.size || prevProps.src !== this.props.src || prevProps.framed !== this.props.framed) {
            this.updateElementSize();
          }
        }
      }, {
        key: "render",
        value: function render() {
          var fixedWidth = this.props.fixedWidth;
          var _this$state = this.state,
              height = _this$state.height,
              width = _this$state.width;
          var style = {
            height: height,
            flexShrink: 0
          };
          if (fixedWidth) style.width = fixedWidth;
          return /*#__PURE__*/_react["default"].createElement("div", {
            ref: this.element,
            style: style
          }, /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, this.props, {
            height: height,
            width: width,
            ratio: this.ratio
          })));
        }
      }, {
        key: "ratio",
        get: function get() {
          var size = this.props.size;
          return this.sizeRatioMap[size];
        }
      }]);

      return Resize;
    }(_react["default"].Component);

    Resize.displayName = "Resized(".concat(WrappedComponent.displayName, ")");
    Resize.propTypes = _objectSpread(_objectSpread({}, WrappedComponent.propTypes), {}, {
      fixedWidth: _propTypes["default"].number
    });
    Resize.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
    return (0, _hoistNonReactStatics["default"])(Resize, WrappedComponent);
  };
};

var _default = resizeHoc;
exports["default"] = _default;